export const FocusRingVariants = {
	Light: 'light',
	Dark: 'dark',
} as const;
export type FocusRingVariantsType = (typeof FocusRingVariants)[keyof typeof FocusRingVariants];
